<template lang="pug">
  div#app
    router-view
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
@import 'app';
@import '../../imports/core/pages/resources/system';
</style>
